import * as React from "react";

import {cst, cstAssign}        from "@Common/react/chain-services";
import {Types}                 from "@Common/types";

import {AccountSelectionModal} from "../../../../common/account-selection-modal/account-selection-modal";

interface VarStack {
    accountSelectionModal : Types.Xpresso.Common.AccountSelectionModal.AccountSelectionModalNext,
}

export const AddressListsSection = ({
    next
}:Types.Xpresso.Account.Company.AddressBookRoute.ComponentPropsAddressListSection) => cst<VarStack>(

    cstAssign("accountSelectionModal", ({}, next) => AccountSelectionModal({urlParam: "/account/admin/office/address-lists", onlyOffice: true, next})),

    ({accountSelectionModal}) => next({
        isLoading : false,
        render    : () => Content({
            onLinkClick : accountSelectionModal.show,
        }),
    }), 
);

const Content = ({onLinkClick: handleLinkClick}) => (
    <div key="address-lists" className="section">
        <div className="header">
            <div className="title" xd-qa-type="label" xd-qa-name="Manage Address Lists">Manage Address Lists</div>
            <div onClick={handleLinkClick} xd-qa-type="link" xd-qa-name="Manage Address Lists" className="edit">Edit</div>
        </div>
    </div>
);
